//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { TEMPLATE_GRID_CARD_WIDTH } from '@components/templates/templateConstants';

export enum SHARE_ACTIONS {
  GET_PUBLISHER_CLIENTS = 'SHARE/GET_PUBLISHER_CLIENTS',
  GET_BAZAARVOICE_DESTINATIONS = 'SHARE/GET_BAZAARVOICE_DESTINATIONS',

  REQUEST_SHARED_MEDIA_AND_STATS = 'SHARE/REQUEST_SHARED_MEDIA_AND_STATS',
  REQUEST_NEXT_SHARED_MEDIA = 'SHARE/REQUEST_NEXT_SHARED_MEDIA',
  REQUEST_FILTERED_SHARED_MEDIA = 'SHARE/REQUEST_FILTERED_SHARED_MEDIA',
  REQUEST_SHARED_MEDIA_BY_CUID = 'SHARE/REQUEST_SHARED_MEDIA_BY_CUID',

  RECEIVE_SHARED_MEDIA_AND_STATS_SUCCEEDED = 'SHARE/RECEIVE_SHARED_MEDIA_AND_STATS_SUCCEEDED',
  RECEIVE_FILTERED_SHARED_MEDIA_SUCCEEDED = 'SHARE/RECEIVE_FILTERED_SHARED_MEDIA_SUCCEEDED',
  RECEIVE_NEXT_SHARED_MEDIA_SUCCEEDED = 'SHARE/RECEIVE_NEXT_SHARED_MEDIA_SUCCEEDED',
  RECEIVE_SHARED_MEDIA_BY_CUID_SUCCEEDED = 'SHARE/RECEIVE_SHARED_MEDIA_BY_CUID_SUCCEEDED',

  RECEIVE_SHARED_MEDIA_FAILED = 'SHARE/RECEIVE_SHARED_MEDIA_FAILED',

  REMOVE_SHARED_ITEMS = 'SHARE/REMOVE_SHARED_ITEMS',

  RESET_SHARED_MEDIA = 'SHARE/RESET_SHARED_MEDIA',
  SET_INITIAL_SETUP_COMPLETE = 'SHARE/SET_INITIAL_SETUP_COMPLETE',
  SET_SHARED_MEDIA_LAST_FETCH = 'SHARE/SET_SHARED_MEDIA_LAST_FETCH',

  GET_MODERATION_STATS = 'SHARE/GET_MODERATION_STATS',
  GET_TAGGED_PRODUCTS_STATS = 'SHARE/GET_TAGGED_PRODUCTS_STATS',

  UPDATE_STATUS_FILTER_VALUE = 'SHARE/UPDATE_STATUS_FILTER_VALUE',
  UPDATE_SEARCH_FILTER_VALUE = 'SHARE/UPDATE_SEARCH_FILTER_VALUE',

  UPDATE_SHOULD_SHOW_ONBOARDING = 'SHARE/UPDATE_SHOULD_SHOW_ONBOARDING',
  UPDATE_CURRENT_ONBOARDING_STEP = 'SHARE/UPDATE_CURRENT_ONBOARDING_STEP',
  UPDATE_SHOULD_SHOW_SOURCE_ERROR = 'SHARE/UPDATE_SHOULD_SHOW_SOURCE_ERROR',
  UPDATE_IS_STYLE_GUIDE_REVIEWED = 'SHARE/UPDATE_IS_STYLE_GUIDE_REVIEWED',
  UPDATE_SHOULD_SHOW_STYLE_GUIDE_ACCEPTANCE_ERROR = 'SHARE/UPDATE_SHOULD_SHOW_STYLE_GUIDE_ACCEPTANCE_ERROR',
}

export enum ShareRoutes {
  MAIN = 'share',
  HASHTAGS_USAGE = 'share-hashtags-usage',
}

export enum ShareStatusFilterValues {
  ALL = 'all',
  UNDER_REVIEW = 'under-review',
  REJECTED = 'brand-rejected',
  APPROVED = 'brand-approved',
  PUBLISHED = 'published',
  NEEDS_PRODUCTS = 'needs-products',
}

export const ShareStatusFilterLabels = {
  [ShareStatusFilterValues.ALL]: 'All Shared Media',
  [ShareStatusFilterValues.PUBLISHED]: 'Published',
  [ShareStatusFilterValues.REJECTED]: 'Brand Rejected',
  [ShareStatusFilterValues.APPROVED]: 'Brand Approved',
  [ShareStatusFilterValues.UNDER_REVIEW]: 'Under Review',
  [ShareStatusFilterValues.NEEDS_PRODUCTS]: 'Needs Products',
};

export enum ShareOnboardingSteps {
  REVIEW = 'review',
  CREATE = 'create',
  TRACKING = 'tracking',
  ALL_SET = 'all_set',
  DONE = 'done',
}

export const GRID_CONTENT_CARD_WIDTH = 204;
export const GRID_CONTENT_CARD_BOTTOM_HEIGHT = 82;
export const SHARE_GRID_IMAGE_WIDTH = TEMPLATE_GRID_CARD_WIDTH;
export const SHARE_GRID_IMAGE_HEIGHT = TEMPLATE_GRID_CARD_WIDTH;
export const SHARE_GRID_CARD_WIDTH = SHARE_GRID_IMAGE_WIDTH;
export const SHARE_GRID_CARD_HEIGHT =
  SHARE_GRID_IMAGE_HEIGHT + GRID_CONTENT_CARD_BOTTOM_HEIGHT;

const shareContentGrid = 'share-content-grid';

export const ShareTrackingIds = {
  SHARE_IMAGE_GRID_CONTAINER: 'share-image-grid-container',
  SHARE_CONTENT_GRID_ITEM: (cuid: string) => `${shareContentGrid}-item-${cuid}`,
  SHARE_CONTENT_GRID_ITEM_PIN: (cuid: string) =>
    `${shareContentGrid}-pin-${cuid}`,
  SHARE_CONTENT_GRID_ITEM_BULK_ADD: (cuid: string) =>
    `${shareContentGrid}-bulk-add-${cuid}`,
  SHARE_CONTENT_GRID_ITEM_REQUEST_RIGHTS: `${shareContentGrid}-request-rights-cta`,
  SHARE_CONTENT_GRID_ITEM_TAG_PRODUCTS: `${shareContentGrid}-tag-products-cta`,
  SHARE_STATS_BAR_LABEL: (label: string) => `stats-bar-label-${label}`,
} as const;
